import { render, staticRenderFns } from "./SceneShareView.vue?vue&type=template&id=4fd7512a&scoped=true"
import script from "./SceneShareView.vue?vue&type=script&lang=js"
export * from "./SceneShareView.vue?vue&type=script&lang=js"
import style0 from "./SceneShareView.vue?vue&type=style&index=0&id=4fd7512a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd7512a",
  null
  
)

export default component.exports